import { redirect } from "@tanstack/react-router";
import { authClient } from "./auth-client";
import type { USGRole } from "./rbac";

export async function requireAuth() {
  const session = await authClient.getSession();
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}

function requireRole(roles: USGRole[]) {
  return async () => {
    const session = await requireAuth();
    if (!(roles as string[]).includes(session.user.role)) {
      throw redirect({ to: "/dashboard" });
    }
    return session;
  };
}

export const requireAdmin = requireRole(["ops"]);
export const requireMgrOrAdmin = requireRole(["ops", "manager"]);
